import { MobiDocument } from './MobiDocument';
import { VaccinDocument } from './VaccinDocument';

export class IndividuVaccinDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private vaccin_id: number;
    private individu_id: number;
    private date: string;

    public constructor(indVaccin: any) {
        super()
        this._id = indVaccin._id;
        this._rev = indVaccin._rev;
        this.id = indVaccin.id;
        this.vaccin_id = indVaccin.vaccin_id;
        this.individu_id = indVaccin.individu_id;
        this.date = indVaccin.date;
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getVaccin_id(): number {
        return this.vaccin_id;
    }

    public setVaccin_id(vaccin_id: number): void {
        this.vaccin_id = vaccin_id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getDate(): string {
        return this.date;
    }

    public setDate(date: string): void {
        this.date = date;
    }

    public getVaccin(): VaccinDocument {
        let vaccin: VaccinDocument = this.memdb.findOne({
            doctype: "VaccinDocument",
            fkey: "id",
            fvalue: this.vaccin_id
        });
        vaccin.setDate(this.date);
        return vaccin;
    }

}